import { Link, useNavigate } from "react-router-dom";
import { Truck, Wallet, UsersThree, ShieldCheck, Gear, SignOut, CaretRight, FileText } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function More() {
  const { user, can, has, logout } = useAuth();
  const navigate = useNavigate();
  const isPatron = user?.role === "patron";

  const items = [
    can("docs_create") && { to: "/devis", label: "Devis", desc: "Propositions, validité, transformation en vente", icon: FileText, testid: "more-quotes" },
    can("suppliers_view") && { to: "/fournisseurs", label: "Fournisseurs", desc: "Achats, dettes en cours", icon: Truck, testid: "more-suppliers" },
    can("expenses_view") && { to: "/depenses", label: "Dépenses", desc: "Ponctuelles et récurrentes", icon: Wallet, testid: "more-expenses" },
    isPatron && has("hr") && { to: "/employes", label: "Employés & RH", desc: "Salaires, primes — patron uniquement", icon: UsersThree, testid: "more-employees" },
    isPatron && { to: "/equipe", label: "Équipe & accès", desc: "Invitations, rôles, permissions", icon: ShieldCheck, testid: "more-team" },
    isPatron && { to: "/parametres", label: "Paramètres", desc: "Abonnement, entreprise, journal d'activité", icon: Gear, testid: "more-settings" },
  ].filter(Boolean);

  return (
    <div className="max-w-xl space-y-4 fade-in" data-testid="more-page">
      <h1 className="font-display font-bold text-2xl">Plus</h1>
      <div className="kcard p-4">
        <p className="font-semibold">{user?.name}</p>
        <p className="text-xs text-gray-500">{user?.email || user?.phone} · <span className="capitalize">{user?.role}</span> · {user?.company?.name}</p>
      </div>
      <div className="space-y-2">
        {items.map(({ to, label, desc, icon: Icon, testid }) => (
          <Link key={to} to={to} data-testid={testid} className="kcard p-4 flex items-center gap-3 hover:shadow-md transition-shadow">
            <Icon size={22} className="text-[#16233D]" />
            <div className="flex-1">
              <p className="font-semibold text-sm">{label}</p>
              <p className="text-xs text-gray-500">{desc}</p>
            </div>
            <CaretRight size={16} className="text-gray-400" />
          </Link>
        ))}
      </div>
      <button data-testid="logout-btn" onClick={async () => { await logout(); navigate("/connexion"); }}
        className="w-full kcard p-4 flex items-center gap-3 text-[#B4432F] hover:shadow-md transition-shadow">
        <SignOut size={20} /> <span className="font-semibold text-sm">Se déconnecter</span>
      </button>
    </div>
  );
}
